// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"App_wrapper__2RLk3","border":"App_border__2WPf3"};